<template>
    <div class="lively-resource">
        <div class="resource-search">
            <div class="search-resource flex flex-mid">
                <p>站点</p>
                <div class="imitate-select" id="pointer-none">
                    <div class="imitate-select-cont" @click.stop="bindChangeSelect($event,0)">
                        <p class="flex-1">{{selectCont}}</p>
                        <i class="iconfont icon-zheng-triangle" :class="{'recover':isShow == 0}"></i>
                    </div>
                    <div :class="['imitate-select-list',{'imitate-select-list-show':isShow == 0}]">
                        <ul>
                            <li v-for="(val,key,index) in selectList" :key="index"><a href="javascript:" @click="copySelect($event,{el:val,key:key})">{{val}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="search-resource flex flex-mid">
                <p>渠道组</p>
                <div class="imitate-select">
                    <div class="imitate-select-cont" @click.stop="bindChangeSelect($event,1)">
                        <p class="flex-1">{{groupCont}}</p>
                        <i class="iconfont icon-zheng-triangle" :class="{'recover':isShow == 1}"></i>
                    </div>
                    <div :class="['imitate-select-list',{'imitate-select-list-show':isShow == 1}]">
                        <ul>
                            <li v-for="(val,key,index) in groupList" :key="index"><a href="javascript:" @click="copyGroup($event,{el:val,key:key})">{{val}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="search-resource flex flex-mid" v-if="allNum[groupKey]">
                <p>渠道资源</p>
                <div class="imitate-select">
                    <div class="imitate-select-cont" @click.stop="bindChangeSelect($event,3)">
                        <p class="flex-1">{{resourceCont}}</p>
                        <i class="iconfont icon-zheng-triangle" :class="{'recover':isShow == 3}"></i>
                    </div>
                    <div :class="['imitate-select-list',{'imitate-select-list-show':isShow == 3}]">
                        <ul>
                            <li v-for="(val,key,index) in resourceList[groupKey]" :key="index"><a href="javascript:" @click="copyResource($event,{el:val,key:key})">{{val}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="seaarch-time flex flex-mid">
                <p>时间类型</p>
                <label class="flex flex-mid" :for="item.name" v-for="(item,index) in selectRange" :key="index">
                    <div class="input-box-radio">
                        <input type="radio" name="time" :value="item.id" v-model="rangeVal" :id="item.name">
                        <span></span>
                    </div>
                    <span>{{item.txt}}</span>
                </label>
            </div>
            <span class="br-wrap" :style="{'width':!allNum[groupKey]?'calc(100% - 810px)':'calc(100% - 1098px)'}"></span>
            <div class="search-resource flex flex-mid">
                <p>渠道媒介</p>
                <div class="imitate-select">
                    <div class="imitate-select-cont" @click.stop="bindChangeSelect($event,2)">
                        <p class="flex-1">{{mediumCont}}</p>
                        <i class="iconfont icon-zheng-triangle" :class="{'recover':isShow == 2}"></i>
                    </div>
                    <div :class="['imitate-select-list',{'imitate-select-list-show':isShow == 2}]">
                        <ul>
                            <li v-for="(val,key,index) in mediumList" :key="index"><a href="javascript:" @click="copyMedium($event,{el:val,key:key})">{{val}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="search-time-scope flex flex-mid">
                <p>时间范围</p>
                <div class="input-box-date" >
                    <input type="text" id="laydaystart" name="daystart" readonly="readonly" placeholder="请选择起始时间">
                    <!-- <input v-show="rangeVal == 'month'" type="text" id="laymonthstart" name="monthstart" readonly="readonly" placeholder="请选择起始时间">
                    <input v-show="rangeVal == 'year'" type="text" id="layyearstart" name="yearstart" readonly="readonly" placeholder="请选择起始时间"> -->
                </div>
                <p>—</p>
                <div class="input-box-date">
                    <input type="text" id="laydayend" name="dayend" readonly="readonly" placeholder="请选择结束时间">
                    <!-- <input v-show="rangeVal == 'month'" type="text" id="laymonthend" name="monthend" readonly="readonly" placeholder="请选择结束时间">
                    <input v-show="rangeVal == 'year'" type="text" id="layyearend" name="yearend" readonly="readonly" placeholder="请选择结束时间"> -->
                </div>
            </div>
            <div class="search-submit">
                <a href="javascript:" @click="submitData">查询</a>
            </div>
        </div>
        <div class="table-box">
            <v-table :ajaxData="tableData"></v-table>
        </div>
    </div>
</template>

<script>
    import VTable from './table/table';
    import {listen,set_start,set_end} from "./table/ajax.js"
    import {mapGetters,mapActions} from "vuex";

    var now = new Date();
    var default_option = {
                    start_min: {
                        year: 1970,
                        month: 0,
                        date: 1,
                    },
                    start_max: {
                        'date': {
                            'year': now.getFullYear(),
                            'month': now.getMonth(),
                            'date': now.getDate()
                        },
                        'month': {
                            'year': now.getFullYear(),
                            'month': now.getMonth()
                        },
                        'year': {
                            'year': now.getFullYear()
                        }
                    },
                    end_min: {
                        year: 1970,
                        month: 0,
                        date: 1,
                    },
                    end_max: {
                        'date': {
                            'year': now.getFullYear(),
                            'month': now.getMonth(),
                            'date': now.getDate()
                        },
                        'month': {
                            'year': now.getFullYear(),
                            'month': now.getMonth()
                        },
                        'year': {
                            'year': now.getFullYear()
                        }
                    },
                }
    export default {
        name:"lively-resource",
        props:['init'],
        data(){
            return {
                isShow:-1,
                prevShow:-1,
                selectCont:"请选择站点",
                selectList:"",
                selectKey:0,
                groupCont:"请选择渠道组",
                groupList:"",
                groupKey:0,
                mediumCont:"请选择渠道媒介",
                mediumList:"",
                mediumKey:0,
                resourceCont:"请选择渠道资源",
                resourceList:{"0":{"0":"全部"}},
                resourceKey:0,
                selectRange:[
                    {name:"day",id:"date",txt:"天"},
                    {name:"month",id:"month",txt:"月"},
                    {name:"year",id:"year",txt:"年"},
                ],
                rangeVal:'date',
                tableData:"",
                start_laydate:"",
                end_laydate:"",
                dataType : {
                    "date": 'yyyy-MM-dd',
                    "month": 'yyyy-MM',
                    "year": 'yyyy',
                },
                // 是否显示渠道资源搜索框
                allNum:{},
            }
        },
        mounted(){
            // 天数选择
            //常规用法
            let _this = this;
            
            var type = this.rangeVal;
            var $start_date = $("#laydaystart"),$end_date = $("#laydayend");
            this.start_laydate = laydate.render({
                elem: "#laydaystart",
                max: 0,
                type: type,
                format: 'yyyy-MM-dd',
                showBottom: true,
                btns:["clear"],
                done: function (value, date, endDate) {
                    set_start($start_date,value, date, endDate,_this.rangeVal,_this.end_laydate,now)
                    if ($start_date.val() == ''){
                        _this.end_laydate.config.min = default_option['end_min'];
                        _this.end_laydate.config.max = default_option['end_max'][_this.rangeVal];
                    }
                },
                change: function (value,date,endDate) {
                    $start_date.val(value,date);
                    set_start($start_date,value, date, endDate,_this.rangeVal,_this.end_laydate,now)
                    $('.layui-laydate-list').on('click', 'li', function () {
                        $('.layui-laydate').hide();
                    });
                    if ($start_date.val() == ''){
                        _this.end_laydate.config.min = default_option['end_min'];
                        _this.end_laydate.config.max = default_option['end_max'][_this.rangeVal];
                    }
                }
            });
            this.end_laydate = laydate.render({
                elem: "#laydayend",
                type: type,
                max: 0,
                format: 'yyyy-MM-dd',
                showBottom: true,
                btns:["clear"],
                done: function (value, date, endDate) {
                    set_end($end_date,value, date, endDate,_this.rangeVal,_this.start_laydate);
                    if ($end_date.val() == ''){
                        _this.start_laydate.config.min = default_option['end_min'];
                        _this.start_laydate.config.max = default_option['end_max'][_this.rangeVal];
                    }
                },
                change: function (value,date,endDate) {
                    set_end($end_date,value, date, endDate,_this.rangeVal,_this.start_laydate);
                    $end_date.val(value,date);
                    $('.layui-laydate-list').on('click', 'li', function () {
                        $('.layui-laydate').hide();
                    });
                    if ($end_date.val() == ''){
                        _this.start_laydate.config.min = default_option['start_min'];
                        _this.start_laydate.config.max = default_option['start_max'][_this.rangeVal];
                    }
                }
            });
            // 点击body 隐藏多选框
            document.body.addEventListener('click',()=>{ 
                this.isShow = this.prevShow =  -1;
            });
            // 
            $.ajax({
                url:webUrl+"/active/getData",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                dataType:"JSON",
                success:(res)=>{
                    this.tableData = res.data.list;
                }
            })
            // 异步更新数据
            // ajax 加载 推广资源和渠道组数据
            $.ajax({
                url:webUrl+"/active/getSelect",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                dataType:"JSON",
                success:(res)=>{
                    let web = res.data.web_name;
                    let group =  res.data.group;
                    let medium =  res.data.medium;
                    let resource =  res.data.resource;
                    web[0] = group[0] = medium[0] = "全部";
                    for(let i in resource){
                        this.allNum[i] = 1;
                    }
                    this.selectList = web;
                    this.groupList = group;
                    this.mediumList = medium;
                    this.resourceList = resource;

                    // 权限判断
                    if(this.getSuper != 1){
                        this.selectCont = web[JSON.parse(localStorage.getItem("get")).belong-1];
                        this.selectKey = JSON.parse(localStorage.getItem("get")).belong-1;
                        this.selectList = {};
                        $("#pointer-none").css("pointer-events","none");
                    }
                }
            });
        },
        watch:{
            "rangeVal":function(val){
                $("#laydaystart").val('');
                $("#laydayend").val('');
                this.start_laydate.config.type = val;
                this.end_laydate.config.type = val;
                this.start_laydate.config.format = this.dataType[val];
                this.end_laydate.config.format = this.dataType[val];

                this.end_laydate.config.min = default_option['end_min'];
                this.end_laydate.config.max = default_option['end_max'][val];
                this.start_laydate.config.min = default_option['start_min'];
                this.start_laydate.config.max = default_option['start_max'][val];
            },
            "init":function(val){
                if(val == "00"){
                    $.ajax({
                        url:webUrl+"/active/getData",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        dataType:"JSON",
                        success:(res)=>{
                            this.tableData = res.data.list;
                        }
                    })
                }
            },
            "groupKey":function(val){
                if(!this.allNum[val]){
                    this.resourceKey = 0;
                }
            }
        },
        computed:{
            ...mapGetters(["getSuper"])
        },
        methods:{
            ...mapActions(['setHint']),
            copySelect(event,val){
                this.selectCont = val.el;
                this.selectKey = val.key;
            },
            copyGroup(event,val){
                this.groupCont = val.el;
                this.groupKey = val.key;
            },
            copyMedium(event,val){
                this.mediumCont = val.el;
                this.mediumKey = val.key;
            },
            copyResource(event,val){
                this.resourceCont = val.el;
                this.resourceKey = val.key;
            },
            submitData(){
                let startTime = document.querySelector("#laydaystart").value;
                let endTime = document.querySelector("#laydayend").value;
                let data = {
                    web:this.selectKey,
                    search_engine:this.groupKey,
                    medium:this.mediumKey,
                    resource_id:this.resourceKey,
                    type:this.rangeVal,
                    start_time:startTime,
                    end_time:endTime
                }
                let _this = this;
                $.ajax({
                    url:webUrl+"/active/getData",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:data,
                    dataType:"JSON",
                    success:function(res){
                        _this.setHint({txt:"请求成功",className:"hint-success"})
                        _this.tableData = res.data.list;
                        
                    }
                })
            },
            bindChangeSelect(event,val){
                if(val == this.prevShow){
                    this.isShow = this.prevShow = -1;
                }else{
                    this.isShow = this.prevShow = val;
                }
            }
        },
        components:{
            VTable:VTable
        }
    }
</script>

<style scoped>
.search-submit a {
    transition-duration: 600ms;
}
.br-wrap {
    display: inline-block;
    width:calc(100% - 810px); 
}
</style>




// WEBPACK FOOTER //
// src/components/main/livelyResource.vue